<div>
  <div class="row" style="padding-top: 20px;" *ngIf="!isLoadingFertigation">
    <div class="col-md-3" [class.col-md-6]="fertigationData?.length===0">
      <h3 class="page-subtitle">Fertigation</h3>
    </div>
    <div class="col">
      <button 
        type="button"
        class="btn btn-outline-primary btn-sm"
        style="width: 90%; border-radius: 5px;"
        data-toggle="modal" 
        data-target="#createFertigationDataModal"
      >
        Create Fertigation Schedule
      </button>
    </div>
    <div class="col mr-1">
      <button 
        type="button"
        class="btn btn-outline-primary btn-sm"
        style="width: 100%; border-radius: 5px;"
        data-toggle="modal" 
        data-target="#addFertigationDataModal"
      >
        Upload Fertigation Schedule CSV
      </button>
    </div>
    <div class="col" *ngIf="varieties">
      <select 
        id="fertVariety"
        name="fertVariety"
        (change)="onVarietyOptionSelected($event)"
        style="width: 90%;"
        ng-model="selection"
        ng-init="selection ='selectedVariety'"
        class="fert-select"
      >
        <option *ngFor="let variety of varieties">{{variety}}</option>
      </select>
    </div>
    <span class="border-right border-secondary" style="height: 30px;" *ngIf="states"></span>
    <div class="col" *ngIf="states">
      <select 
        id="fertState"
        name="fertState"
        (change)="onStateOptionSelected($event)"
        style="width: 90%;"
        ng-model="selection"
        ng-init="selection ='selectedState'"
        class="fert-select"
      >
        <option *ngFor="let state of states">{{state}}</option>
      </select>
    </div>
  </div>
  <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingFertigation">
    <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
  </div>
  <hr *ngIf="!isLoadingFertigation">
  <div *ngIf="fertigationData?.length===0 && !isLoadingFertigation" style="text-align: center;">
    No fertigation schedule uploaded yet...
  </div>
  <div *ngIf="fertigationData?.length>0">
    <div style="text-align: center;" class="mt-3" *ngIf="!scheduleExists">
      No fertigation schedule uploaded for {{this.selectedState}} for the selected variety...
    </div>
    <div *ngIf="scheduleExists">
      <div>
        <ul class="nav nav-tabs">
          <li class="nav-item mr-5"><a class="nav-link active" data-target="#recommendationTab" data-toggle="tab">Fertilizer Recommendations</a></li>
          <li class="nav-item"><a class="nav-link" data-target="#scheduleTab" data-toggle="tab">Fertigation Schedules</a></li>
        </ul>
      </div>
      <div class="tab-content">
        <div id="recommendationTab" class="tab-pane active">
          <div class="row mt-5 mb-2">
            <div class="col-md-9 bold mt-2">
            </div>
            <div class="col">
              <button 
                type="button" 
                class="btn btn-outline-primary btn-sm"
                style="width: 170px; border-radius: 5px;"
                data-toggle="modal" 
                data-target="#addRecoStagesModal"
              >
                Create new stage
              </button>
            </div>
          </div>
          <hr>
          <div *ngIf="(fertilizerRecommendation | json) == '{}'" style="text-align: center;" class="mt-3">
            No recommended fertilizers added yet...
          </div>
          <div *ngFor="let item_ of fertilizerRecommendation | keyvalue; let i = index">
            <div class="row bold mt-5 mb-1">
              <div class="col-md-7 bold">
                STAGE {{i+1}}: {{item_.key | stringReplace:'_':' ' | titlecase}}
              </div>
              <div class="col">
                <button
                  id="editStage"
                  type="button" 
                  class="stage-butt"
                  data-toggle="modal" 
                  data-target="#editRecoStagesModal"
                  (click)="setStageData(item_)"
                >
                  Edit stage
                </button>
              </div>
              <div class="col">
                <button
                  id="delStage"
                  type="button" 
                  class="stage-butt"
                  data-toggle="modal" 
                  data-target="#deleteRecomStageModal"
                  (click)="setStageData(item_)"
                >
                  Delete stage
                </button>
              </div>
              <div class="col">
                <button 
                  type="button" 
                  style="width: 110px;" 
                  class="btn btn-primary btn-sm"  
                  data-toggle="modal" 
                  data-target="#addRecomSourceModal"
                  (click)="setStageData(item_)"
                >
                  Add Source
                </button>
              </div>
            </div>
            <div *ngIf="item_.value?.length===0" style="text-align: center; margin-top: 10px;">
              No sources added to this stage yet...
            </div>
            <div>
              <table class="table table-bordered table-primary" style="width: 30%" *ngIf="item_.value?.length>0">
                <thead>
                  <tr class="text-uppercase">
                    <th scope="col">Source</th>
                    <th scope="col">Dose</th>
                    <th scope="col">Dose Units</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let val_ of item_.value">
                    <td>
                      {{val_.source}}
                    </td>
                    <td>
                      {{val_.dose}}
                    </td>
                    <td>
                      {{val_.units}}
                    </td>
                    <td>
                      <span class="editIcon ml-5 mr-4">
                        <i 
                          class="fas fa-pen" 
                          style="font-size: 12px;" 
                          title="Edit" 
                          data-toggle="modal" 
                          data-target="#editRecomSourceModal" 
                          (click)="setRecomSourceData(item_.key, val_)"
                        ></i>
                      </span>
                      <span class="delIcon">
                        <i 
                          class="fa fa-remove" 
                          style="font-size: 16px;" 
                          title="Remove" 
                          data-toggle="modal" 
                          data-target="#deleteSourceModal" 
                          (click)="setRecomSourceData(item_.key, val_)"
                        ></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    
        <div id="scheduleTab" class="tab-pane">
          <div class="row mt-5 mb-2">
            <div class="col-md-9 bold mt-2">
            </div>
            <div class="col">
              <button 
                type="button" 
                class="btn btn-outline-primary btn-sm"
                style="width: 100%; border-radius: 5px;"
                data-toggle="modal" 
                data-target="#addGrowthStagesModal"
              >
                Create new stage
              </button>
            </div>
            <div class="col">
              <input 
                class="search-source py-1 px-2" 
                type="text" 
                name="searchSource"
                placeholder="Search source"
                style="padding: 0px 5px; width: 90%;"
              >
            </div>
          </div>
          <hr>
          <div *ngIf="!isLoadingFertigation">
            <div *ngIf="fertigationSchedule?.length===0" style="text-align: center; margin-bottom: 20px;">
              No growth stages added yet...
            </div>
            <div *ngIf="fertigationSchedule">
              <div class="mb-3" *ngFor="let item of fertigationSchedule">
                <div *ngIf="(item[1] | json) != '{}'">
                  <div class="row">
                    <div class="col-md-7 bold">
                      STAGE {{item[1].stage_number}}: 
                      {{item[1].stage_name}} 
                      ({{item[1].number_of_days[0]}} - {{item[1].number_of_days[1]}} days)
                    </div>
                    <div class="col">
                      <button
                        id="editStage"
                        type="button" 
                        class="stage-butt"
                        data-toggle="modal" 
                        data-target="#editGrowthStagesModal"
                        (click)="setSingleStageData(item)"
                      >
                        Edit stage
                      </button>
                    </div>
                    <div class="col">
                      <button
                        id="delStage"
                        type="button" 
                        class="stage-butt"
                        data-toggle="modal" 
                        data-target="#deleteStageModal"
                        (click)="setSingleStageData(item)"
                      >
                        Delete stage
                      </button>
                    </div>
                    <div class="col">
                      <button 
                        type="button" 
                        style="width: 110px;" 
                        class="btn btn-primary btn-sm"  
                        data-toggle="modal" 
                        data-target="#addSource"
                        (click)="setSingleStageData(item)"
                      >
                        Add Source
                      </button>
                    </div>
                  </div>
    
                  <div *ngIf="item[1].data?.length===0" style="text-align: center; margin-top: 10px;">
                    No sources added to this stage yet...
                  </div>
                  <div class="mt-2 mb-5" *ngIf="item[1].data?.length>0">
                    <table class="table table-bordered table-primary">
                      <thead>
                        <tr class="text-uppercase">
                          <th scope="col">Source</th>
                          <th scope="col">Dose</th>
                          <th scope="col">Dose Units</th>
                          <th scope="col">Interval</th>
                          <th scope="col">Frequency</th>
                          <th scope="col">Rate</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody class="fertigation-table">
                        <tr *ngFor="let val of item[1].data;">
                          <td>
                            <div *ngFor="let source of val.source" class="py-2">
                              {{source}}
                            </div>
                          </td>
                          <td>
                            <div *ngFor="let dose of val.dose" class="py-2">
                              {{dose}}
                            </div>
                          </td>
                          <td>
                            <div *ngFor="let dose_units of val.dose_units" class="py-2">
                              {{dose_units}}
                            </div>
                          </td>
                          <td>
                            <div *ngFor="let application_interval of val.application_interval" class="py-2">
                              {{application_interval}}
                            </div>
                          </td>
                          <td>
                            <div *ngFor="let number_of_applications of val.number_of_applications" class="py-2">
                              {{number_of_applications}}
                            </div>
                          </td>
                          <td>
                            <div *ngFor="let rate of val.rate" class="py-2">
                              {{rate}}
                            </div>
                          </td>
                          <td>
                            <div *ngFor="let source of val.source" class="py-2">
                              <span class="editIcon ml-5 mr-4">
                                <i 
                                  class="fas fa-pen" 
                                  style="font-size: 12px;" 
                                  title="Edit" 
                                  data-toggle="modal" 
                                  data-target="#editSourceModal" 
                                  (click)="setSourceData(item[0], source, val)"
                                ></i>
                              </span>
                              <span class="delIcon">
                                <i 
                                  class="fa fa-remove" 
                                  style="font-size: 16px;" 
                                  title="Remove" 
                                  data-toggle="modal" 
                                  data-target="#removeSourceModal" 
                                  (click)="setSourceData(item[0], source, val)"
                                ></i>
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Upload fertigation csv file data modal -->
<div class="modal fade" id="addFertigationDataModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true" style="overflow: auto;">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;">Upload Fertigation Schedule</h5>
            <button type="button" class="close close-btn"  aria-hidden="true" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <form
              class="form"
              #addFertigationDataForm="ngForm"
              (ngSubmit)="UploadFertigationSchedule(addFertigationDataForm.value)"
              id="scheduleCsvForm"
            >
              <div class="form-group">
                <label for="state">Upload csv file</label>
                  <input
                    type="file"
                    class="form-control file-input"
                    id="schedule_file"
                    name="schedule_file"
                    #schedule_file="ngModel"
                    [(ngModel)]="model.schedule_file"
                    (change)="changeFile($event)"
                    accept=".xls, .xlsx"
                    required
                  >
                  <div
                    *ngIf="schedule_file.touched && !schedule_file.valid"
                    class="text-danger error_message"
                  >
                    <span *ngIf="schedule_file.hasError('required')">
                      Please the file is required, upload one
                    </span>
                  </div>
              </div>
              <br>
              <div>
                <button
                  type="submit"
                  class="btn btn-primary float-right"
                  [disabled]="!addFertigationDataForm.form.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Upload file
                </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

<!-- Create fertigation schedule data modal -->
<div class="modal fade" id="createFertigationDataModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true" style="overflow: auto;">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">
    <div class="modal-content container-fluid">
      <div class="modal-header no-border">
        <h5 class="modal-title text text-primary" style="font-weight: bold;">Create Fertigation Schedule</h5>
        <button type="button" class="close close-btn"  aria-hidden="true" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <form
          class="form"
          #createFertigationDataForm="ngForm"
          (ngSubmit)="createFertigationSchedule(createFertigationDataForm.value)"
          id="creatscheduleForm"
        >
          <div class="form-group">
            <label for="state"> Select State</label>
              <select 
                id="state"
                name="state"
                #state="ngModel"
                [(ngModel)]="model.state"
                style="width: 100%;"
                class="fert-select form-control"
                required
              >
                <option hidden disabled selected value> -- select a state -- </option>
                <option *ngFor="let state of indiaStates">{{state}}</option>
              </select>
          </div>
          <br>
          <div>
            <button
              type="submit"
              class="btn btn-primary float-right"
              [disabled]="!createFertigationDataForm.form.valid"
            >
            <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
            </span>
            <span *ngIf="loading" class="mx-2">Loading...</span>
            <span *ngIf="!loading">
              Create Schedule
            </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Add source modal -->
<div class="modal fade" tabindex="-1" role="dialog" id="addSource">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">Add source</h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          class="form" 
          #addSourceForm="ngForm"
          (ngSubmit)="addSource(addSourceForm.value)"
          id="addSourceForm"
        >
          <div class="form-group">
            <label for="fertiliserName">Fertiliser name</label>
            <input 
              type="text" 
              class="form-control" 
              id="fertiliserName"
              name="source" 
              #source="ngModel" 
              [(ngModel)]="model.source"
              required
            >
            <div
              *ngIf="source.touched && !source.valid"
              class="text-danger error_message"
            >
              <span *ngIf="source.hasError('required')">
                Please the source name is required
              </span>
            </div>  
          </div>
          <div class="form-group">
            <label for="rate">Rate</label>
            <input 
              type="number" 
              class="form-control" 
              id="fertiliserRate"
              name="rate" 
              #rate="ngModel" 
              [(ngModel)]="model.rate"
              required
            >
            <div
              *ngIf="rate.touched && !rate.valid"
              class="text-danger error_message"
            >
              <span *ngIf="rate.hasError('required')">
                Please the rate is required
              </span>
            </div> 
          </div>
          <div class="form-group">
            <label for="frequency">Frequency</label>
            <input 
              type="number" 
              class="form-control" 
              id="frequency"
              name="number_of_applications" 
              #number_of_applications="ngModel" 
              [(ngModel)]="model.number_of_applications"
              required
            >
            <div
              *ngIf="number_of_applications.touched && !number_of_applications.valid"
              class="text-danger error_message"
            >
              <span *ngIf="number_of_applications.hasError('required')">
                Please the frequency is required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="interval">Application Interval</label>
            <input 
              type="text" 
              class="form-control" 
              id="interval"
              name="application_interval" 
              #application_interval="ngModel" 
              [(ngModel)]="model.application_interval"
            >
          </div>
          <div class="form-group">
            <label for="nutrients_group">Nutrients group</label>
            <input 
              type="text" 
              class="form-control" 
              id="nutrients_group"
              name="nutrients_group" 
              #nutrients_group="ngModel" 
              [(ngModel)]="model.nutrients_group"
              required
            >
            <div
              *ngIf="nutrients_group.touched && !nutrients_group.valid"
              class="text-danger error_message"
            >
              <span *ngIf="nutrients_group.hasError('required')">
                Please the nutrients group is required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="dose_units">Dose units</label>
            <input 
              type="text" 
              class="form-control" 
              id="dose_units"
              name="dose_units" 
              #dose_units="ngModel" 
              [(ngModel)]="model.dose_units"
              required
            >
            <div
              *ngIf="dose_units.touched && !dose_units.valid"
              class="text-danger error_message"
            >
              <span *ngIf="dose_units.hasError('required')">
                Please the dose units are required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="how_to_apply">How to apply</label>
            <input 
              type="text" 
              class="form-control" 
              id="how_to_apply"
              name="how_to_apply" 
              #how_to_apply="ngModel" 
              [(ngModel)]="model.how_to_apply"
            >
          </div>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!addSourceForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Add source
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Edit source modal -->
<div class="modal fade" tabindex="-1" role="dialog" id="editSourceModal">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">Edit source</h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          *ngIf="singleSourceData"
          class="form" 
          #editSourceForm="ngForm"
          (ngSubmit)="editSource(editSourceForm.value)"
          id="editSource"
        >
          <div class="form-group">
            <label for="fertiliserName">Fertiliser name</label>
            <input 
              type="text" 
              class="form-control" 
              id="fertiliser"
              name="source" 
              #source="ngModel" 
              [(ngModel)]="singleSourceData.source[sourceIndex]"
              required
            >
            <div
              *ngIf="source.touched && !source.valid"
              class="text-danger error_message"
            >
              <span *ngIf="source.hasError('required')">
                Please the source name is required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="rate">Rate</label>
            <input 
              type="number" 
              class="form-control" 
              id="rate"
              name="rate" 
              #rate="ngModel" 
              [(ngModel)]="singleSourceData.rate[sourceIndex]"
              required
            >
            <div
              *ngIf="rate.touched && !rate.valid"
              class="text-danger error_message"
            >
              <span *ngIf="rate.hasError('required')">
                Please the rate is required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="frequency">Frequency</label>
            <input 
              type="number" 
              class="form-control" 
              id="frequenci"
              name="number_of_applications" 
              #number_of_applications="ngModel" 
              [(ngModel)]="singleSourceData.number_of_applications[sourceIndex]"
              required
            >
            <div
              *ngIf="number_of_applications.touched && !number_of_applications.valid"
              class="text-danger error_message"
            >
              <span *ngIf="number_of_applications.hasError('required')">
                Please the frequency is required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="interval">Application Interval</label>
            <input 
              type="text" 
              class="form-control" 
              id="intervo"
              name="application_interval" 
              #application_interval="ngModel" 
              [(ngModel)]="singleSourceData.application_interval[sourceIndex]"
            >
          </div>
          <div class="form-group">
            <label for="nutrients_group">Nutrients group</label>
            <input 
              type="text" 
              class="form-control" 
              id="nutrientsGroup"
              name="nutrients_group" 
              #nutrients_group="ngModel" 
              [(ngModel)]="singleSourceData.nutrients_group"
              required
            >
            <div
              *ngIf="nutrients_group.touched && !nutrients_group.valid"
              class="text-danger error_message"
            >
              <span *ngIf="nutrients_group.hasError('required')">
                Please the nutrients group is required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="dose_units">Dose units</label>
            <input 
              type="text" 
              class="form-control" 
              id="doseUnits"
              name="dose_units" 
              #dose_units="ngModel" 
              [(ngModel)]="singleSourceData.dose_units[sourceIndex]"
              required
            >
            <div
              *ngIf="dose_units.touched && !dose_units.valid"
              class="text-danger error_message"
            >
              <span *ngIf="dose_units.hasError('required')">
                Please the dose units are required
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="how_to_apply">How to apply</label>
            <input 
              type="text" 
              class="form-control" 
              id="howToApply"
              name="how_to_apply" 
              #how_to_apply="ngModel" 
              [(ngModel)]="singleSourceData.how_to_apply"
            >
          </div>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!editSourceForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save source
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Remove source modal -->
<div class="modal fade" id="removeSourceModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-primary">Remove {{sourceName}}?</h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          </button>
      </div>

      <div class="modal-body">
        Are you sure you want to remove <span class="font-weight-bold">{{sourceName}}</span> from the list permanently?
      </div>
      <div class="modal-footer no-border">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger ml-2" (click)="removeSource(sourceName)">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
          </span>
          <span *ngIf="loading" class="mx-2">Loading...</span>
          <span *ngIf="!loading">
            Delete
          </span>   
        </button>	            
      </div>	          
    </div>	
  </div> 
</div>

<!-- Add growth stages modal -->
<div class="modal fade" id="addGrowthStagesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">New growth stage</h5>
      </div>
      <div class="modal-body">
        <form
          class="form" 
          #addGrowthStageForm="ngForm"
          (ngSubmit)="createGrowthStage(addGrowthStageForm.value)"
          id="addStageForm"
        >
          <div class="form-group">
            <label for="stageNo">Stage Number</label>
            <input 
              type="number" 
              class="form-control" 
              id="stageNo"
              name="stage_number" 
              #stage_number="ngModel" 
              [(ngModel)]="model.stage_number"
              required
            >
            <div
              *ngIf="stage_number.touched && !stage_number.valid"
              class="text-danger error_message"
            >
              <span *ngIf="stage_number.hasError('required')">
                Please the stage number is required
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="startDay">Start Day</label>
                <input 
                  type="number" 
                  class="form-control" 
                  id="startDay"
                  name="start_day" 
                  #start_day="ngModel" 
                  [(ngModel)]="model.start_day"
                  required
                >
                <div
                  *ngIf="start_day.touched && !start_day.valid"
                  class="text-danger error_message"
                >
                  <span *ngIf="start_day.hasError('required')">
                    Please the start day is required
                  </span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="endDay">End Day</label>
                <input 
                  type="number" 
                  class="form-control" 
                  id="endDay"
                  name="end_day" 
                  #end_day="ngModel" 
                  [(ngModel)]="model.end_day"
                  required
                >
                <div
                  *ngIf="end_day.touched && !end_day.valid"
                  class="text-danger error_message"
                >
                  <span *ngIf="end_day.hasError('required')">
                    Please the end day is required
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="stageDescription">Description</label>
            <input 
              type="text" 
              class="form-control" 
              id="stageDescription"
              name="stage_description" 
              #stage_description="ngModel" 
              [(ngModel)]="model.stage_description"
              pattern="^([a-zA-Z0-9\s]*)$"
              required
            >
            <div
              *ngIf="stage_description.touched && !stage_description.valid"
              class="text-danger error_message"
            >
              <span *ngIf="stage_description.hasError('required')">
                Please the stage description is required
              </span>
              <span *ngIf="stage_description.hasError('pattern')">
                Please enter a valid stage description
              </span>
            </div>
          </div>
          <br>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!addGrowthStageForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save stage
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Edit growth stages modal -->
<div class="modal fade" id="editGrowthStagesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">Edit growth stage</h5>
      </div>
      <div class="modal-body">
        <form
          *ngIf="singleStageData"
          class="form" 
          #editGrowthStageForm="ngForm"
          (ngSubmit)="editGrowthStage(editGrowthStageForm.value)"
          id="editStageForm"
        >
          <div class="form-group">
            <label for="stageNo">Stage Number</label>
            <input 
              type="number" 
              class="form-control" 
              id="stageno"
              name="stage_number" 
              #stage_number="ngModel" 
              [(ngModel)]="singleStageData[1].stage_number"
              required
            >
            <div
              *ngIf="stage_number.touched && !stage_number.valid"
              class="text-danger error_message"
            >
              <span *ngIf="stage_number.hasError('required')">
                Please the stage number is required
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label for="startDay">Start Day</label>
                <input 
                  type="number" 
                  class="form-control" 
                  id="startday"
                  name="start_day" 
                  #start_day="ngModel" 
                  [(ngModel)]="singleStageData[1].number_of_days[0]"
                  required
                >
                <div
                  *ngIf="start_day.touched && !start_day.valid"
                  class="text-danger error_message"
                >
                  <span *ngIf="start_day.hasError('required')">
                    Please the start day is required
                  </span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="endDay">End Day</label>
                <input 
                  type="number" 
                  class="form-control" 
                  id="endday"
                  name="end_day" 
                  #end_day="ngModel" 
                  [(ngModel)]="singleStageData[1].number_of_days[1]"
                  required
                >
                <div
                  *ngIf="end_day.touched && !end_day.valid"
                  class="text-danger error_message"
                >
                  <span *ngIf="end_day.hasError('required')">
                    Please the end day is required
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="stageDescription">Description</label>
            <input 
              type="text" 
              class="form-control" 
              id="stagedescription"
              name="stage_description" 
              #stage_description="ngModel" 
              [(ngModel)]="singleStageData[1].stage_name"
              pattern="^([a-zA-Z0-9\s]*)$"
              required
            >
            <div
              *ngIf="stage_description.touched && !stage_description.valid"
              class="text-danger error_message"
            >
              <span *ngIf="stage_description.hasError('required')">
                Please the stage description is required
              </span>
              <span *ngIf="stage_description.hasError('pattern')">
                Please enter a valid stage description
              </span>
            </div>
          </div>
          <br>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!editGrowthStageForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save stage
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Delete growth stage modal-->
<div class="modal fade" id="deleteStageModal" tabindex="-1" role="dialog" aria-labelledby="deleteStageModal"
aria-hidden="true">
 <div class="modal-dialog modal-dialog-centered" role="document">
   <div class="modal-content" *ngIf="singleStageData">
     <div class="modal-header no-border">
       <h5 class="modal-title text-primary">Remove stage {{singleStageData[1].stage_number}} ?</h5>
       <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
        </button>
     </div>

     <div class="modal-body">
       Are you sure you want to remove <span class="font-weight-bold">"{{ singleStageData[1].stage_name }}"</span> from the list permanently?
     </div>
     <div class="modal-footer no-border">
       <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
       <button type="button" class="btn btn-danger ml-2" (click)="deleteGrowthStage(stageName)">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
          </span>
          <span *ngIf="loading" class="mx-2">Loading...</span>
          <span *ngIf="!loading">
            Remove
          </span>
        </button>	            
     </div>	          
   </div>	
 </div> 
</div> 

<!-- Add recommendation stages -->
<div class="modal fade" id="addRecoStagesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">New stage</h5>
      </div>
      <div class="modal-body">
        <form
          class="form" 
          #addRecommendationStageForm="ngForm"
          (ngSubmit)="createStage(addRecommendationStageForm.value)"
          id="createStageForm"
        >
          <div class="form-group">
            <label for="stageName">Description</label>
            <input 
              type="text" 
              class="form-control" 
              id="stageName"
              name="stage_description" 
              #stage_description="ngModel" 
              [(ngModel)]="model.stage_description"
              pattern="^([a-zA-Z0-9\s]*)$"
              required
            >
            <div
              *ngIf="stage_description.touched && !stage_description.valid"
              class="text-danger error_message"
            >
              <span *ngIf="stage_description.hasError('required')">
                Please the stage description is required
              </span>
              <span *ngIf="stage_description.hasError('pattern')">
                Please enter a valid stage description
              </span>
            </div>
          </div>
          <br>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeAddModal()">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!addRecommendationStageForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save stage
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Edit recommendations stages -->
<div class="modal fade" id="editRecoStagesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">Edit stage</h5>
      </div>
      <div class="modal-body">
        <form
          class="form" 
          #editRecommendationStageForm="ngForm"
          (ngSubmit)="editStage(editRecommendationStageForm.value)"
          id="updateStageForm"
          *ngIf="recomStageData"
        >
          <div class="form-group">
            <label for="stageName">Description</label>
            <input 
              type="text" 
              class="form-control" 
              id="stageName"
              name="stage_description" 
              #stage_description="ngModel" 
              [ngModel]="recomStageData.key | stringReplace:'_':' '"
              (ngModelChange)="recomStageData.key=$event"
              pattern="^([a-zA-Z0-9\s]*)$"
              required
            >
            <div
              *ngIf="stage_description.touched && !stage_description.valid"
              class="text-danger error_message"
            >
              <span *ngIf="stage_description.hasError('required')">
                Please the stage description is required
              </span>
              <span *ngIf="stage_description.hasError('pattern')">
                Please enter a valid stage description
              </span>
            </div>
          </div>
          <br>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!editRecommendationStageForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save stage
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Delete recommendation stage modal -->
<div class="modal fade" id="deleteRecomStageModal" tabindex="-1" role="dialog" aria-labelledby="deleteRecomStageModal"
aria-hidden="true">
 <div class="modal-dialog modal-dialog-centered" role="document">
   <div class="modal-content">
     <div class="modal-header no-border">
       <h5 class="modal-title text-primary">Remove stage?</h5>
       <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
         <span aria-hidden="true">&times;</span>
        </button>
     </div>

     <div class="modal-body">
       Are you sure you want to remove <span class="font-weight-bold">"{{ stageName }}"</span> from the list permanently?
     </div>
     <div class="modal-footer no-border">
       <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
       <button type="button" class="btn btn-danger ml-2" (click)="deleteStage(stageName)">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
          </span>
          <span *ngIf="loading" class="mx-2">Loading...</span>
          <span *ngIf="!loading">
            Remove
          </span>
        </button>	            
     </div>	          
   </div>	
 </div> 
</div>

<!-- Add source recommendations modal -->
<div class="modal fade" tabindex="-1" role="dialog" id="addRecomSourceModal">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">Add source</h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          class="form" 
          #addRecomSourceForm="ngForm"
          (ngSubmit)="createRecomSource(addRecomSourceForm.value)"
          id="createSourceForm"
        >
          <div class="form-group">
            <label for="sourceName">Fertiliser name</label>
            <input 
              type="text" 
              class="form-control" 
              id="sourceName"
              name="source" 
              #source="ngModel" 
              [(ngModel)]="model.source"
              required
            >
            <div
              *ngIf="source.touched && !source.valid"
              class="text-danger error_message"
            >
              <span *ngIf="source.hasError('required')">
                Please the source name is required
              </span>
            </div>  
          </div>
          <div class="form-group">
            <label for="rate">Dose</label>
            <input 
              type="number" 
              class="form-control" 
              id="dose"
              name="dose" 
              #dose="ngModel" 
              [(ngModel)]="model.dose"
              required
            >
            <div
              *ngIf="dose.touched && !dose.valid"
              class="text-danger error_message"
            >
              <span *ngIf="dose.hasError('required')">
                Please the dose is required
              </span>
            </div> 
          </div>
          <div class="form-group">
            <label for="units">Dose units</label>
            <input 
              type="text" 
              class="form-control" 
              id="units"
              name="units" 
              #units="ngModel" 
              [(ngModel)]="model.units"
              required
            >
            <div
              *ngIf="units.touched && !units.valid"
              class="text-danger error_message"
            >
              <span *ngIf="units.hasError('required')">
                Please the dose units are required
              </span>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!addRecomSourceForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Add source
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Edit source recommendations modal -->
<div class="modal fade" tabindex="-1" role="dialog" id="editRecomSourceModal">
  <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-muted font-weight-bold text-primary">Edit source</h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form
          class="form" 
          #updateRecomSourceForm="ngForm"
          (ngSubmit)="updateRecomSource(updateRecomSourceForm.value)"
          id="updateSourceForm"
          *ngIf="recomSourceData"
        >
          <div class="form-group">
            <label for="sourceName">Fertiliser name</label>
            <input 
              type="text" 
              class="form-control" 
              name="source" 
              #source="ngModel" 
              [(ngModel)]="recomSourceData.source"
              required
            >
            <div
              *ngIf="source.touched && !source.valid"
              class="text-danger error_message"
            >
              <span *ngIf="source.hasError('required')">
                Please the source name is required
              </span>
            </div>  
          </div>
          <div class="form-group">
            <label for="rate">Dose</label>
            <input 
              type="number" 
              class="form-control" 
              name="dose" 
              #dose="ngModel" 
              [(ngModel)]="recomSourceData.dose"
              required
            >
            <div
              *ngIf="dose.touched && !dose.valid"
              class="text-danger error_message"
            >
              <span *ngIf="dose.hasError('required')">
                Please the dose is required
              </span>
            </div> 
          </div>
          <div class="form-group">
            <label for="units">Dose units</label>
            <input 
              type="text" 
              class="form-control" 
              id="units"
              name="units" 
              #units="ngModel" 
              [(ngModel)]="recomSourceData.units"
              required
            >
            <div
              *ngIf="units.touched && !units.valid"
              class="text-danger error_message"
            >
              <span *ngIf="units.hasError('required')">
                Please the dose units are required
              </span>
            </div>
          </div>
          <div>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button 
              type="submit" 
              class="btn btn-primary ml-2"
              [disabled]="!updateRecomSourceForm.form.valid"
            >
              <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>
              <span *ngIf="loading" class="mx-2">Loading...</span>
              <span *ngIf="!loading">
                Save changes
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Delete recommendation source modal -->
<div class="modal fade" id="deleteSourceModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header no-border">
        <h5 class="modal-title text-primary">Remove {{sourceName}}?</h5>
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          </button>
      </div>

      <div class="modal-body">
        Are you sure you want to remove <span class="font-weight-bold">{{sourceName}}</span> from the list permanently?
      </div>
      <div class="modal-footer no-border">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger ml-2" (click)="deleteSource(sourceName)">
          <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
          </span>
          <span *ngIf="loading" class="mx-2">Loading...</span>
          <span *ngIf="!loading">
            Delete
          </span>   
        </button>	            
      </div>	          
    </div>	
  </div> 
</div>
